<div *ngIf="!showForHistory" class="flex-start-start">
  <div class="truncate-inline hover-underline pointer text-truncate">
    <span *ngIf="title" [ngClass]="titleClass" (click)="openInSameTab()">
      {{title}}
    </span>
  </div>
  <div>
    <i class="open-link-icon pl-2 fal fa-external-link-alt pointer" (click)="openInExsistingTab()"></i>
  </div>
</div>

<!-- this is for coustomer order log history -->
<span *ngIf="showForHistory">
  <span [ngClass]="showForHistory ? 'hover-underline {{titleClass}}' : '{{titleClass}}'" *ngIf="title" (click)="openInSameTab()">
    RO# {{title}}
  </span>
  <i class="open-link-icon pl-2 fal fa-external-link-alt pointer" (click)="openInExsistingTab()"></i>
  <span>&nbsp;:</span>
</span>
